tag = document.createElement("script")
tag.src = "https://player.vimeo.com/api/player.js"
document.head.appendChild(tag, "beforeEnd")
